:host {
  display: block;
}

.spw-header-persona {
  position: relative;
  @include under-breakpoint(lg) {
    margin: 12px 0;
    border-bottom: 1px solid var(--spw-colors-support-grey-grey-300);
    padding-bottom: 16px;
  }

  &__active-persona {
    position: relative;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-weight: bold;
    @include breakpoint(lg) {
      display: none;
    }
  }

  &__trigger {
    display: block;
    @include breakpoint(lg) {
      display: none;
    }
    .spw-header-persona--opened & {
      transform: rotate(180deg);
    }
  }

  &__dropdown {
    display: none;
    .spw-header-persona--opened & {
      display: block;
      @include breakpoint(lg) {
        display: flex;
      }
    }
    @include breakpoint(lg) {
      display: flex;
    }
  }
}
